module.exports = __webpack_public_path__ + "img/ccdlogo_white.caf7a63b.png";